<template>
  <div class="tab">
    <el-tabs id="tabsList"
      :value="tabActiveName"
      type="card"
      @tab-click="selectedTabHandle"
      @tab-remove="removeTabHandle">
      <el-tab-pane v-for="item in tabs" :key="item.name" :label="item.name" :name="item.name" :closable="item.closable"></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import { TOGGLE_MENU_FROM_WHERE } from '../../utils/config'

  export default {
    name: 'tab',
    data() {
      return {}
    },
    computed: {
      ...mapGetters([
        'tabs',
        'tabActiveName'
      ])
    },
    created() {},
    methods: {
      selectedTabHandle (tab) {
        this.setSubMenuActiveName(tab.name)
        let t = this.tabs.find(f => f.name === tab.name)
        if (tab.name !== '首页') {
          this.setCurrentRoles(tab.name)
        }
        this.$router.push({ path: t.url })
      },
      removeTabHandle (tabName) {
        let newTabs = this.tabs.filter(item => item.name !== tabName)
        this.setNewTabs(newTabs)
        this.$router.push({ path: '/index' })
      },
      ...mapMutations({
        setNewTabs: 'SET_NEWTABS',
        setSubMenuActiveName: 'SET_SUB_MENU_ACTIVE_NAME',
        setCurrentRoles: 'SET_CURRENT_ROLES'
      })
    }
  }
</script>

<style lang="stylus">
  .tab
    padding 0 30px
    user-select none
    height 50px
    display flex
    align-items center
    background #fff
    border-top 1px solid #e8e8e8;
    .el-tabs--card
      &>.el-tabs__header
        margin 0
        border 0
        .el-tabs__nav
          border 0
          .el-tabs__item
            border 1px solid #E4E7ED
            margin-right 5px
            &:first-child
              border 1px solid #E4E7ED
            .el-icon-close
                width 14px
</style>
